import {addNetECG, deleteNetECG, editNetECG, getAllNetECGs} from "../api/netecg";
import {DbCustomer, NetECG, netECGSchema} from "sharedlibs";
import {NetECGProductFormValues} from "../components/forms/productForms/NetECGProductForm";

export class NetECGService {

  static async getNetECGs() {
    return await getAllNetECGs()
  }

  static async deleteNetECG(id: string) {
    return await deleteNetECG(id);
  }

  static async addNetECG(customer: DbCustomer, formObject: NetECGProductFormValues) {
    const netECG = netECGSchema.parse({
      ...formObject,
      customerName: customer.name,
      customerNumber: customer.customerNumber,
      customerId: customer.id
    })

    await addNetECG(netECG)
  }

  static async updateNetECG(netECG: NetECG, productForm: NetECGProductFormValues) {
    const newNetECG = netECGSchema.parse(
      {
        id: netECG.id,
        customerId: netECG.customerId,
        serialNumberChargingDock: productForm.serialNumberChargingDock,
        serialNumber: productForm.serialNumber,
        customerNumber: netECG.customerNumber,
        evaluationSoftware: productForm.evaluationSoftware,
        customerName: netECG.customerName,
        batchNumber: productForm.batchNumber
      } as NetECG
    )

    await editNetECG(newNetECG)
  }
}
